import axios from 'axios';
import config from '../config';

const { api: apiConfig } = config;

const serviceTypesAxios = axios.create({
  baseURL: `${apiConfig.API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
serviceTypesAxios.interceptors.request.use(
  (config) => {
    const authUser = sessionStorage.getItem('authUser');
    if (authUser) {
      const user = JSON.parse(authUser);
      if (user && user.token) {
        config.headers.Authorization = `Bearer ${user.token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
serviceTypesAxios.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const message = error.response?.data?.message || error.message || 'Erro na requisição';
    return Promise.reject(new Error(message));
  }
);

export interface ServiceType {
  id: string;
  name: string;
  description?: string;
  code?: string;
  parentId?: string;
  breadcrumb: string;
  level: number;
  displayOrder: number;
  isActive: boolean;
  requiresApproval: boolean;
  defaultPrice?: number;
  estimatedHours?: number;
  children?: ServiceType[];
}

export interface GetAllServiceTypesResult {
  serviceTypes: ServiceType[];
}

export const serviceTypesService = {
  /**
   * Get all service types (hierarchical structure)
   */
  getAll: async (onlyActive: boolean = true, onlyRoot: boolean = false): Promise<GetAllServiceTypesResult> => {
    const params = new URLSearchParams();
    params.append('onlyActive', onlyActive.toString());
    params.append('onlyRoot', onlyRoot.toString());

    return serviceTypesAxios.get(`/service-types?${params.toString()}`);
  },
};
